<template>
	<v-container class="d-flex flex-column flex-nowrap file-upload-center-container py-2 px-3"
		v-if="hasUploads || forgeProcessingMessages.length > 0">
		<div class="file-upload-center-inner-container">
			<div v-if="hasUploads">
				<p class="font-weight-bold body-2 text-primary mb-1">Subiendo archivos ({{Object.keys(filesToUploadCenter).length}})</p>
				<div v-for="(fileKey, index) in Object.keys(filesToUploadCenter)" :key="index" style="width: 100%;position:relative;">
				<div class="pb-2">
					<div class="d-flex flex-row justify-space-between">
						<p class="caption mb-0 text--secondary">{{filesToUploadCenter[fileKey].type | uploadType}} - {{filesToUploadCenter[fileKey].description}}</p>
						<p class="caption mb-0 text--secondary">{{filesToUploadCenter[fileKey].loaded | fileSize}}/{{filesToUploadCenter[fileKey].total | fileSize}}@{{filesToUploadCenter[fileKey] | uploadSpeed}}</p>
					</div>
					<p class="caption mb-0"><span class="font-weight-bold light-blue-text">{{filesToUploadCenter[fileKey].file.name}}</span></p>
				</div>
				<v-progress-linear
					v-if="filesToUploadCenter[fileKey].status"
					class="listing-loading-bar"
					buffer-value="0"
					:value="filesToUploadCenter[fileKey].loaded*100/filesToUploadCenter[fileKey].total"
					stream
					color="#5e85ef"
				></v-progress-linear>
				</div>
			</div>
			<v-divider v-if="hasUploads" class="my-2"></v-divider>
			<div v-if="forgeProcessingMessages.length > 0" class="forge-processing-section">
				<div class="d-flex align-center mb-1">
					<v-progress-circular class="mr-2" color="#5E85EF" indeterminate :size="18" :width="2"></v-progress-circular>
					<p class="font-weight-bold body-2 text-primary mb-0">Procesando en Autodesk Forge ({{forgeProcessingMessages.length}})</p>
				</div>
				<p v-for="message in forgeProcessingMessages" :key="message.file_id || message.forge_file_id || message.uuid" class="caption mb-0 text--secondary forge-processing-file">
					{{message.title || message.file_name || message.forge_file_name}}
				</p>
			</div>
		</div>
	</v-container>
</template>

<script>
import moment from 'moment'
export default {
	name: 'FileUploadCenter',
	components: { },
	computed: {
		filesToUploadCenter() {
			return this.$store.globalStore.state.filesToUploadCenter
		},
		hasUploads() {
			return Object.keys(this.filesToUploadCenter).length > 0
		},
		forgeProcessingMessages() {
			return Object.values(this.$store.globalStore.state.forgeProcessingFiles)
		}
	},
	filters: {
		uploadType: function (value) {
			const types = [
				'',
				'Tarea',
				'Interacción Tarea',
				'RDI',
				'Interacción RDI',
				'Adicional',
				'Revisión Adicional',
				'Observación Rev. Adicional',
				'Archivo Forge',
				'Plano',
				'Estado Pago',
				'Estado Pago',
				'Estado Pago',
				'Borrador',
				'Archivo'
			]
			return types[value]
		},
		fileSize: function (value) {
			const size = Math.round(value/10000) / 100 + 'Mb'
			return size
		},
		uploadSpeed: function (file) {
			const now = moment()
			const diff = now.diff(file.start, 'seconds')
			const speed = ( Math.round( (file.loaded/10000) / diff ) / 100 ).toFixed(2) + 'Mbps'
			return speed
		}
	},
	data: () => ({}),
	mounted(){
		this.startProcessingFiles()
	},
	methods: {
		startProcessingFiles(){
			
		}
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.light-blue-text{color: #5E85EF;}
	.file-upload-center-container{
		position: fixed;
		bottom: 55px;
		right: 20px;
		background-color: white;
		max-width: 420px;
		max-height: 500px;
		border-radius: 10px;
		border: 2px solid #2D4B95;
		z-index: 99999;
	}
	.file-upload-center-inner-container{
		width: 100%;
	}
	.forge-processing-section{
		max-height: 105px;
		overflow-y: auto;
	}
	.forge-processing-file{
		padding-left: 26px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.listing-loading-bar{
		position: absolute;
		bottom: 0;
	}
</style>